<template>
  <div class="vertical-center-box">
    <el-select class="mr-r4" v-model="searchText.field" :filterable="true" style="width: 50%;">
      <el-option v-for="field in searchFieldOptions" :key="field.fieldId" :label="field.fieldName" :value="field.fieldId" />
    </el-select>
    <el-popover class="mr-r4" trigger="manual" style="width: 100%;" placement="bottom-start" :visible-arrow="false" :width="searchHistoryWidth" v-model="historyToolVisible">
      <ul class="lists">
        <li class="search-list mr-b4 vertical-center-box" v-for="(keyword, index) in searchKeywords" :key="`${keyword}_${index}`">
          <el-row class="vertical-center-box c-pointer" type="flex" justify="space-between" style="width: 100%;">
            <span class="high" @click="onClickHistory(keyword)" style="word-break: break-all;">
              {{ keyword }}
            </span>
            <div align="right">
              <span class="c-pointer" @click="onDeleteByIndex(index)"><i class="far fa-times mr-r10" /></span>
            </div>
          </el-row>
        </li>
        <li class="mr-t10">
          <div align="right">
            <el-button size="mini" @click="onDeleteAllHistory">모두 삭제</el-button>
          </div>
        </li>
      </ul>
      <el-input ref="searchTool" class="searchTool" slot="reference" v-model="searchText.value"
        @keyup.enter.native="addSearchTag" @focus="onFocusSearchTool" @blur="onBlurSearchTool"/>
    </el-popover>
    <el-button class="mr-r4" type="primary" size="small" @click="addSearchTag">검색</el-button>
    <el-checkbox v-model="searchText.regex" true-label="Y" false-label="N">정규표현식</el-checkbox>
    <w-log-regex-search-info-button class="mr-l4" />
  </div>
</template>

<script>
import { isEmpty, findIndex, cloneDeep } from 'lodash';

import msgUtils from '@/utils/message';
import WLogRegexSearchInfoButton from '../components/LogRegexSearchInfoButton';

export default {
  name: 'WLogSearchField',
  components: {
    WLogRegexSearchInfoButton,
  },
  props: {
    fieldOptions: Array,
    searchKeywords: Array,
  },
  data() {
    return {
      historyToolVisible: false,
      searchHistoryWidth: 0,
      searchText: {},
      searchFieldOptions: [],
    };
  },
  watch: {
    fieldOptions: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.searchFieldOptions = cloneDeep(value);
          const timestampIdx = findIndex(this.searchFieldOptions, (item) => item.fieldId === 'timestamp');
          this.searchFieldOptions.splice(timestampIdx, 1);
          this.searchText = {
            field: value[0].fieldId,
            value: '',
            regex: 'N',
            label: '',
          };
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setSearchHistoryWidth();
    });
  },
  methods: {
    setSearchHistoryWidth() {
      this.searchHistoryWidth = this.$refs.searchTool.$refs.input.clientWidth;
    },
    onFocusSearchTool() {
      this.setSearchHistoryWidth();
      if (isEmpty(this.searchKeywords)) {
        this.historyToolVisible = false;
      } else if (!this.historyToolVisible) {
        this.historyToolVisible = true;
      }
    },
    onBlurSearchTool() {
      this.historyToolVisible = false;
    },
    onDeleteAllHistory() {
      this.$emit('delete-all-history');
    },
    onDeleteByIndex(index) {
      this.$emit('delete-hist-by-index', index);
      if (this.searchKeywords.length - 1 !== 0) {
        this.$refs.searchTool.focus();
      }
    },
    onClickHistory(row) {
      const regex = this.searchText.regex;
      const index = findIndex(this.fieldOptions, (item) => item.fieldId === this.searchText.field);
      const label = this.fieldOptions[index].fieldName;
      this.searchText = {
        field: this.fieldOptions[index].fieldId,
        value: row,
        label,
        regex,
      };
    },
    addSearchTag() {
      if (isEmpty(this.searchText.value)) {
        this.$message(msgUtils.getCustomMsgData('검색어를 입력해주세요.'));
        return;
      }
      const index = findIndex(this.fieldOptions, (item) => item.fieldId === this.searchText.field);
      const label = `${this.fieldOptions[index].fieldName} : ${this.searchText.value}`;
      const searchText = {
        ...this.searchText,
        label,
      };
      this.$emit('add-search-tag', searchText);
      const regex = this.searchText.regex;
      this.searchText = {
        field: this.fieldOptions[0].fieldId,
        value: '',
        label: '',
        regex,
      };
    },
  },
};
</script>

<style scoped>
.search-list {
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
}
.search-list:hover {
  background-color: #FAECC5;
}
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/components/LogSearchField.vue